import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import About from "./pages/about";
import Map from "./pages/map";
import Research from "./pages/research.js";
import Login from "./pages/login.js";
import Mailbox from "./pages/mailbox.js";
import DataInput from "./pages/datainput.js";
import { DataProvider } from "./components/DataContext";
import Admin from "./pages/admin.js";
import "./i18n";

const App = () => {
  return (
    <div className="bg-gray-100 min-h-screen flex flex-col">
       <DataProvider>
      <Router>
        <div className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/map" element={<Map />} />
            <Route path="/research" element={<Research />} />
            <Route path="/login" element={<Login />} />
            <Route path="/data-input" element={<DataInput />}/>
            <Route path="/mailbox" element={<Mailbox />}/>
            <Route path="/admin" element={<Admin />}/>
          </Routes>
        </div>
      </Router>
      </DataProvider>
    </div>
  );
};

export default App;
